import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { PenIcon, CloseIcon } from "@graphiql/react";
import { useState } from "react";
import { listFragmentInfos } from "../lib/fragments.js";
const FragmentItem = (t0) => {
  const $ = c(35);
  const {
    name,
    typeName,
    active: t1,
    onFocus,
    onRename,
    onDelete
  } = t0;
  const active = t1 === void 0 ? false : t1;
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(name);
  let t2;
  if ($[0] !== draft || $[1] !== name || $[2] !== onRename) {
    t2 = function commit2() {
      setEditing(false);
      const next = draft.trim();
      if (next && next !== name) {
        onRename == null ? void 0 : onRename(name, next);
      } else {
        setDraft(name);
      }
    };
    $[0] = draft;
    $[1] = name;
    $[2] = onRename;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const commit = t2;
  let t3;
  if ($[4] !== name) {
    t3 = function cancel2() {
      setEditing(false);
      setDraft(name);
    };
    $[4] = name;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const cancel = t3;
  if (editing) {
    const t42 = `Rename fragment ${name}`;
    let t52;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t52 = (e) => setDraft(e.target.value);
      $[6] = t52;
    } else {
      t52 = $[6];
    }
    let t62;
    if ($[7] !== cancel || $[8] !== commit) {
      t62 = (e_0) => {
        if (e_0.key === "Enter") {
          commit();
        } else {
          if (e_0.key === "Escape") {
            cancel();
          }
        }
      };
      $[7] = cancel;
      $[8] = commit;
      $[9] = t62;
    } else {
      t62 = $[9];
    }
    let t72;
    if ($[10] !== commit || $[11] !== draft || $[12] !== t42 || $[13] !== t62) {
      t72 = /* @__PURE__ */ jsx("li", { className: "graphiql-qb-fragment-item", children: /* @__PURE__ */ jsx("input", { className: "graphiql-qb-fragment-rename", value: draft, autoFocus: true, "aria-label": t42, onChange: t52, onBlur: commit, onKeyDown: t62 }) });
      $[10] = commit;
      $[11] = draft;
      $[12] = t42;
      $[13] = t62;
      $[14] = t72;
    } else {
      t72 = $[14];
    }
    return t72;
  }
  let t4;
  if ($[15] !== name) {
    t4 = /* @__PURE__ */ jsx("span", { className: "graphiql-qb-fragment-name", children: name });
    $[15] = name;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== typeName) {
    t5 = /* @__PURE__ */ jsxs("span", { className: "graphiql-qb-fragment-type", children: [
      "on ",
      /* @__PURE__ */ jsx("span", { className: "graphiql-qb-fragment-type-name", children: typeName })
    ] });
    $[17] = typeName;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t4 || $[20] !== t5) {
    t6 = /* @__PURE__ */ jsxs(Fragment, { children: [
      t4,
      t5
    ] });
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  const label = t6;
  const t7 = `graphiql-qb-fragment-item${active ? " graphiql-qb-fragment-item--active" : ""}`;
  let t8;
  if ($[22] !== active || $[23] !== label || $[24] !== name || $[25] !== onFocus) {
    t8 = onFocus ? /* @__PURE__ */ jsx("button", { type: "button", className: "graphiql-qb-fragment-open graphiql-qb-fragment-open--button", "aria-current": active ? "true" : void 0, "aria-label": `Edit fragment ${name}`, onClick: () => onFocus(name), children: label }) : /* @__PURE__ */ jsx("span", { className: "graphiql-qb-fragment-open", children: label });
    $[22] = active;
    $[23] = label;
    $[24] = name;
    $[25] = onFocus;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== name || $[28] !== onDelete || $[29] !== onRename) {
    t9 = (onRename || onDelete) && /* @__PURE__ */ jsxs("span", { className: "graphiql-qb-fragment-actions", children: [
      onRename && /* @__PURE__ */ jsx("button", { type: "button", className: "graphiql-qb-fragment-rename-btn", "aria-label": `Rename fragment ${name}`, onClick: () => {
        setDraft(name);
        setEditing(true);
      }, children: /* @__PURE__ */ jsx(PenIcon, {}) }),
      onDelete && /* @__PURE__ */ jsx("button", { type: "button", className: "graphiql-qb-fragment-delete-btn", "aria-label": `Delete fragment ${name}, inlining it where spread`, onClick: () => onDelete(name), children: /* @__PURE__ */ jsx(CloseIcon, {}) })
    ] });
    $[27] = name;
    $[28] = onDelete;
    $[29] = onRename;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== t7 || $[32] !== t8 || $[33] !== t9) {
    t10 = /* @__PURE__ */ jsxs("li", { className: t7, children: [
      t8,
      t9
    ] });
    $[31] = t7;
    $[32] = t8;
    $[33] = t9;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  return t10;
};
const FragmentSection = (t0) => {
  const $ = c(7);
  const {
    doc,
    activeFragmentName,
    onFocusFragment,
    onRenameFragment,
    onDeleteFragment
  } = t0;
  let t1;
  if ($[0] !== activeFragmentName || $[1] !== doc || $[2] !== onDeleteFragment || $[3] !== onFocusFragment || $[4] !== onRenameFragment) {
    const fragments = listFragmentInfos(doc);
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = /* @__PURE__ */ jsx("h3", { className: "graphiql-qb-fragment-heading", children: "Fragments" });
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = /* @__PURE__ */ jsxs("section", { className: "graphiql-qb-fragment-section", "aria-label": "Fragments", children: [
      t2,
      fragments.length === 0 ? /* @__PURE__ */ jsx("p", { className: "graphiql-qb-fragment-empty", children: "No fragments defined." }) : /* @__PURE__ */ jsx("ul", { className: "graphiql-qb-fragment-list", role: "list", children: fragments.map((t3) => {
        const {
          name,
          typeName
        } = t3;
        return /* @__PURE__ */ jsx(FragmentItem, { name, typeName, active: name === activeFragmentName, onFocus: onFocusFragment, onRename: onRenameFragment, onDelete: onDeleteFragment }, name);
      }) })
    ] });
    $[0] = activeFragmentName;
    $[1] = doc;
    $[2] = onDeleteFragment;
    $[3] = onFocusFragment;
    $[4] = onRenameFragment;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export {
  FragmentSection
};
//# sourceMappingURL=fragment-section.js.map
